import { defineComponent } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination } from 'swiper/modules';
import * as api from '@src/api/auth';
import type { PortalBannerItem } from '@src/api/auth';
import { getOSSImageUrl } from '@src/utils/ossImage';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';

export default defineComponent({
    name: 'PortalBanner',
    setup() {
        const bannerlist = ref<PortalBannerItem[]>([]);

        const getBannerList = async () => {
            const { data } = await api.getPortalBannerList();
            bannerlist.value = data;
        };
        const openJumpUrl = (url: string) => {
            window.open(url, '_blank');
        };

        getBannerList();

        return () => (
            <div class='portal-banner g-h-full g-w-full'>
                <Swiper modules={[Autoplay, Pagination]} space-between={0} autoplay={true} loop={true} pagination={{ clickable: true }}>
                    {bannerlist.value.map(v => (
                        <SwiperSlide key={v.id}>
                            <img
                                class='g-cursor-pointer'
                                src={getOSSImageUrl(v.httpUrl, { resize: { width: 400, height: 610, fit: 'cover' } })}
                                alt={v.title}
                                onClick={() => openJumpUrl(v?.jumpTo)}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        );
    },
});
